import { i18n } from '@/plugins/i18n';
import { ElNotification } from 'element-plus';

type NotifyType = 'success' | 'warning' | 'info' | 'error' | 'stripe';

const notifyWrapper = (
  type: NotifyType = 'error',
  key = 'DEFAULT',
  isIndividual = false,
) => {
  const errorPath = `store.${type}.${key}`;
  let notificationType: 'success' | 'warning' | 'info' | 'error' = type as any;
  let errorMessage = `${errorPath}.text`;
  let titleMessage = `${errorPath}.title`;

  if (type === 'stripe') {
    errorMessage = `stripe.error_codes.${key}`;
    titleMessage = 'stripe.stripe_error_title';
    notificationType = 'error';

    if (!i18n.global.te(errorMessage)) {
      errorMessage = 'stripe.stripe_error_default_text';
    }
  }

  if (isIndividual && i18n.global.te(`${errorMessage}Individual`)) {
    errorMessage = `${errorMessage}Individual`;
  }

  ElNotification({
    title: i18n.global.te(titleMessage)
      ? i18n.global.t(titleMessage)
      : i18n.global.t(`store.${type}.DEFAULT.title`),
    message: i18n.global.te(errorMessage)
      ? i18n.global.t(errorMessage)
      : i18n.global.t(`store.${type}.DEFAULT.text`),
    type: notificationType,
  });
};

export default notifyWrapper;
